import {
  Field,
  FieldLabel,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Textarea,
} from '@monksflow/monks-ui';
import { useTranslation } from 'react-i18next';
import {
  REQUIREMENTS,
  SCOPES,
  requirementLabel,
  scopeLabel,
  type ProvenanceDraft,
} from './provenance';

interface ProvenanceFieldsProps {
  idPrefix: string;
  draft: ProvenanceDraft;
  onChange: (next: ProvenanceDraft) => void;
}

/** How a value applies - the same fields for spec values and limits. */
export function ProvenanceFields({ idPrefix, draft, onChange }: ProvenanceFieldsProps) {
  const { t } = useTranslation('admin');
  const set = (patch: Partial<ProvenanceDraft>) => onChange({ ...draft, ...patch });

  return (
    <>
      <div className="grid grid-cols-2 gap-md">
        <Field>
          <FieldLabel htmlFor={`${idPrefix}-requirement`}>
            {t('admin.adFormats.spec.requirement')}
          </FieldLabel>
          <Select value={draft.requirement} onValueChange={(requirement) => set({ requirement })}>
            <SelectTrigger id={`${idPrefix}-requirement`}>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {REQUIREMENTS.map((value) => (
                <SelectItem key={value} value={value}>
                  {requirementLabel(t, value)}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </Field>
        <Field>
          <FieldLabel htmlFor={`${idPrefix}-scope`}>{t('admin.adFormats.spec.scope')}</FieldLabel>
          <Select value={draft.scope} onValueChange={(scope) => set({ scope })}>
            <SelectTrigger id={`${idPrefix}-scope`}>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {SCOPES.map((value) => (
                <SelectItem key={value} value={value}>
                  {scopeLabel(t, value)}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </Field>
      </div>
      <Field>
        <FieldLabel htmlFor={`${idPrefix}-notes`}>{t('admin.adFormats.fields.notes')}</FieldLabel>
        <Textarea
          id={`${idPrefix}-notes`}
          value={draft.notes}
          onChange={(event) => set({ notes: event.target.value })}
        />
      </Field>
    </>
  );
}
